import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { GATEWAY_PAYMENT_TOKEN } from '../../../config/cacheKey';
import EmptyPageStyle from '../../../pages/emptyPageStyle/emptyPageStyle';
import PaymentReceiptSkeleton from '../../../pages/requestSteps/inquiryFee/resultPayment/paymentReceiptSkeleton';
import { GetInstallmentsPaymentResult } from '../../../services/payment.service';
import { Button, Typography, Grid } from "@mui/material";
import { useDispatch } from 'react-redux';
import { getNextInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import { useAuth } from '../../../config/AuthProvider/authProvider';


function InstallmentPaymentReceipt({ setState }: any) {
    const [data, setData] = useState<any>();
    const [isData, SetIsData] = useState<boolean>(false);
    const queryClient = useQueryClient();
    const { referenceKey, setRefKey } = useAuth();
    const getTokenFromLocal = localStorage.getItem(GATEWAY_PAYMENT_TOKEN)
    const { mutate: GetInstallmentsPaymentResultMutation, isLoading } = useMutation(GetInstallmentsPaymentResult, {
        onSuccess: (data) => {
            if (data.isSuccess) {
                setData(data.data)
                SetIsData(false)
                setRefKey(data.data.referenceKey
                )
            }
            else {
                SetIsData(true)
            }
        }
    });
    const myUrl = queryClient.getQueryData("URL_PARAMS") as any
    useEffect(() => {
        const token = myUrl?.token;
        GetInstallmentsPaymentResultMutation({ gatewayInstallmentsPaymentToken: token?.get('t') });
        queryClient.setQueryData("URL_PARAMS", '')
    }, [])
    if (isLoading) {
        return <PaymentReceiptSkeleton />
    }
    if (isData) {
        return <EmptyPageStyle prefixText="رسید پرداختی" highlightedText=" یافت" suffixText="نشد" />
    }
    const handleClick = () => {
        setState('AssignedLoans')
        // dispatch(getNextInnerState({ nextInnerState: `FutureLoans` }));
    }
    return (
        <div
            style={{
                background: 'none',
                border: 'none !important',
                position: 'relative',
                width: '100%',
                maxWidth: '600px',
                margin: 'auto',
                backgroundImage: `url(/images/PaymentReceipt.png)`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%',
                backgroundPosition: 'top center',
                height: '370px',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                overflow: 'hidden',
                color: '#212121'
            }}
        >
            <Grid container spacing={2} justifyContent="center ">
                <Grid item xs={12} textAlign="center" className="  !mt-7">
                    <div style={{ fontSize: '1.2rem' }}  >{data?.amount?.toLocaleString('fa')} ریال</div>
                    {data?.paymentStatus === 'Verified' ? <div className="bgSecondaryColorLight badge mt-4 mb-6">
                        <CheckCircleIcon />
                        &nbsp;پرداخت موفق
                    </div> : <div className=" badge mt-4 mb-6" style={{ background: '#FF617C' }}>
                        <CancelIcon />
                        &nbsp;پرداخت ناموفق
                    </div>}

                </Grid>

                <Grid item xs={12}>
                    <hr className="indented-hr" />
                </Grid>

                <Grid container item xs={12} className="!mx-6" textAlign="center">

                    <Grid container xs={12} className="mt-2" >
                        {data?.trackingNumber && <><Grid item xs={6} textAlign="right" className="!mt-4 ">شماره پیگیری:</Grid><Grid item xs={6} textAlign="left" className="!mt-4">{data?.trackingNumber}</Grid></>}
                        {data?.paymentDatePersian && <><Grid item xs={6} textAlign="right" className="!mt-4 ">تاریخ و زمان پرداخت:</Grid><Grid item xs={6} textAlign="left" className="!mt-4">{data?.paymentDatePersian}</Grid></>}
                        <Grid item xs={6} textAlign="right" className="!mt-4 ">  درگاه پرداخت:</Grid>
                        <Grid item xs={6} textAlign="left" className="!mt-4 ">{data?.gateway} </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Button

                            onClick={handleClick}
                            sx={{
                                alignItems: "center", height: "42px",
                                paddingInline: "1rem",
                                backgroundColor: '#BBA57A',
                                color: '#fff !important',

                            }}>
                            <Typography >
                                لیست اقساط
                            </Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default InstallmentPaymentReceipt